import GmtEventPusher from '../gtm-event-pusher'; //to-do: add npm version import

/**
 * vehicle search analytics
 *
 */
const vehicleSearchAnalytics = function() {

  const selectInputs = document.querySelectorAll('#vehicle-search-form select');
  selectInputs.forEach(input => {
    input.addEventListener('change', e => {
      try {
        const value = e.target.value;
        const name = e.target.name.replace('[]',''); //model[] -> model
        const path = e.path || (e.composedPath && e.composedPath());
        const advancedFilter = path.some(element => element.classList && element.classList.contains('vehicle-search__additional-filters'));

        if(name && value) {
          GmtEventPusher.formatGAEventToDataLayer('CarSearch', advancedFilter ? 'extended' : 'simple', 'Search', name, value);
        }
      } catch(e) {
        console.log(e);
      }
    });
  });

}

/**
 * hero vehicle search analytics
 *
 */
const heroVehicleSearchAnalytics = function() {

  const selectInputs = document.querySelectorAll('.hero-vehicle-search__filters select');
  selectInputs.forEach(input => {

    input.addEventListener('change', e => {
      try {
        const value = e.target.value;
        const name = e.target.name.replace('[]',''); //model[] -> model
        if(name && value) {
          GmtEventPusher.formatGAEventToDataLayer('CarSearch', 'frontPage', 'Search', name, value);
        }
      } catch(e) {
        console.log(e);
      }
    });
  });

}

/**
 * search watcher analytics
 *
 */
const searchWatcherAnalytics = function() {

  const selectInputs = document.querySelectorAll('#vehicle-search-watcher-form select, #vehicle-search-watcher-form input[type="text"]');
  selectInputs.forEach(input => {
    input.addEventListener('change', e => {
      try {
        const value = e.target.value;
        const name = e.target.name.replace('[]',''); //model[] -> model
        const path = e.path || (e.composedPath && e.composedPath());
        const advancedFilter = path.some(element => element.classList && element.classList.contains('search-watcher__additional-filters'));

        if(name && value) {
          GmtEventPusher.formatGAEventToDataLayer('SearchReminder', advancedFilter ? 'extended' : 'simple', 'Search', name, value);
        }
      } catch(e) {
        console.log(e);
      }
    });
  });

}


/**
 * Carousel related analytics (made for vehicle carousel)
 *
 * @param {object} carousel carousel element
 * @param {string} [carouselName=''] name of carousel for analytics
 */
const carouselAnalytics = function(carousel, carouselName = '') {

  const slideContainer = carousel.querySelector('.glide__slides');
  slideContainer.addEventListener('click', (e) => {
    try {
      const targetElement = e.target.closest('.glide__slide');
      const activeImg = targetElement.getElementsByTagName('img')[0].alt; //carousel image alt should contain the description of the slide contents.
      const index = [...targetElement.parentElement.children].indexOf(targetElement) + 1;
      const carouselTitle = carousel.closest('.vehicle-carousel').querySelector('.vehicle-carousel__heading').innerHTML;
      GmtEventPusher.formatGAEventToDataLayer('Carousel', carouselName, `Carousel "${carouselTitle}" click slot ${index}`, 'vehicle', activeImg);
    } catch(e) {
      console.log(e)
    }
  });
}

export default {
  vehicleSearchAnalytics,
  heroVehicleSearchAnalytics,
  carouselAnalytics,
  searchWatcherAnalytics
}
